import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import { compose, mapProps, withHandlers } from 'recompose';
import { reject, contains } from 'ramda';
import { t } from '../../../../modules/infra/i18n';
import ReportsFilter from '../reportsFilter';
import {
  updateCategoryFilter,
  categoryFilterSelectAll,
  categoryFilterDeselectAll,
} from '../actions';
import {
  getServiceCategoryFilters,
  getServiceCategoryFiltersAllChecked,
  getActiveCategoryIds,
} from '../selectors';
import fetchCategories from '../../services/categories/fetchCategories';

const ServiceCategoryFilter = ({ updateFilter, serviceCategoryFilters, allChecked, title }) => {
  return (
    <div className="c-form-input-group__item u-visible-for-extralarge-and-up">
      <div
        className="c-label u-ml--"
      >
        {t('reports:service_category_filter.label')}
      </div>
      <ReportsFilter
        title={title}
        filters={serviceCategoryFilters}
        updateStatusViewed={updateFilter}
        allChecked={allChecked}
        showSelectAll
      />
    </div>
  );
};

ServiceCategoryFilter.propTypes = {
  updateFilter: PropTypes.func.isRequired,
  serviceCategoryFilters: PropTypes.array.isRequired,
  removeFilters: PropTypes.array,
  allChecked: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

ServiceCategoryFilter.defaultProps = {
  removeFilters: [],
  allChecked: false,
};

const mapStateToProps = state => ({
  serviceCategoryFilters: getServiceCategoryFilters(state),
  allChecked: getServiceCategoryFiltersAllChecked(state),
  title: `${t('reports:service_category_filter.title')} ${
    getServiceCategoryFiltersAllChecked(state)
      ? t('reports:service_category_filter.all')
      : `(${getActiveCategoryIds(state).length})`
  }`,
});

const mapDispatchToProps = {
  updateCategoryFilter,
  categoryFilterSelectAll,
  categoryFilterDeselectAll,
};

const removeFilters = mapProps(props => ({
  ...props,
  serviceCategoryFilters: reject(item => contains(item.title, props.removeFilters), props.serviceCategoryFilters),
}));

const handlers = withHandlers({
  updateFilter: props => (category) => {
    if (category === true) {
      return props.categoryFilterSelectAll();
    }

    if (category === false) {
      return props.categoryFilterDeselectAll();
    }

    return props.updateCategoryFilter(category);
  },
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  removeFilters,
  handlers,
  fetchCategories
);

export default enhance(ServiceCategoryFilter);
